// src/App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';
import Header from './components/Header';
import Footer from './components/Footer';
import Accueil from './pages/Accueil';
import LeMuseeEnBref from './pages/LeMuseeEnBref';
import SesCollections from './pages/SesCollections';
import LeCHETOM from './pages/LeChetom';
import TravaillerAuMusee from './pages/TravaillerAuMusee';
import LaBoutique from './pages/LaBoutique';
import SesMissions from './pages/SesMissions';
import SesConferences from './pages/SesConferences';
import DevenirAdherent from './pages/DevenirAdherent';
import DonationSuccess from './pages/DonationSuccess';
import DonationCancel from './pages/DonationCancel';
import EspaceAdherent from './pages/EspaceAdherent';
import ActualitesMusee from './pages/ActualitesMusee';
import ActualitesAAMTDM from './pages/ActualitesAAMTDM';
import FormulairesContact from './pages/FormulairesContact';
import FormulaireChetom from './pages/FormulaireChetom';
import FormulaireMusee from './pages/FormulaireMusee';
import FormulaireAssociation from './pages/FormulaireAssociation';
import InformationsPratiques from './pages/InformationsPratiques';
import VisiteGuidee from './pages/VisiteGuidee';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentCancel from './pages/PaymentCancel';
import CGV from './pages/CGV';
import InformationsLegales from './pages/InformationsLegales';
import RegistrationCancel from './pages/RegistrationCancel';
import RegistrationSuccess from './pages/RegistrationSuccess';
import FaireUnDon from './pages/FaireUnDon';
import NosPartenaires from './pages/NosPartenaires';

// Composant pour suivre les vues de page
const TrackPageView = () => {
  const location = useLocation();

  useEffect(() => {
    ReactGA.pageview(location.pathname + location.search);
  }, [location]);

  return null;
};

const App = () => {
  return (
    <Router>
      <Header />
      <TrackPageView />
      <Routes>
        <Route path="/" element={<Accueil />} />
        <Route path="pages/lemuseeenbref" element={<LeMuseeEnBref />} />
        <Route path="pages/sescollections" element={<SesCollections />} />
        <Route path="pages/lechetom" element={<LeCHETOM />} />
        <Route path="pages/travailleraumusee" element={<TravaillerAuMusee />} />
        <Route path="pages/laboutique" element={<LaBoutique />} />
        <Route path="pages/sesmissions" element={<SesMissions />} />
        <Route path="pages/sesconferences" element={<SesConferences />} />
        <Route path="pages/DevenirAdherent" element={<DevenirAdherent />} />
        <Route path="pages/DonationSuccess" element={<DonationSuccess />} />
        <Route path="pages/DonationCancel" element={<DonationCancel />} />
        <Route path="pages/Login" element={<EspaceAdherent />} />
        <Route path="pages/ActualitesMusee" element={<ActualitesMusee />} />
        <Route path="pages/ActualitesAAMTDM" element={<ActualitesAAMTDM />} />
        <Route path="pages/FaireUnDon" element={<FaireUnDon />} />
        <Route path="pages/FormulairesContact" element={<FormulairesContact />} />
        <Route path="pages/FormulaireChetom" element={<FormulaireChetom />} />
        <Route path="pages/FormulaireMusee" element={<FormulaireMusee />} />
        <Route path="pages/FormulaireAssociation" element={<FormulaireAssociation />} />
        <Route path="pages/informationsPratiques" element={<InformationsPratiques />} />
        <Route path="pages/VisiteGuidee" element={<VisiteGuidee />} />
        <Route path="pages/PaymentSuccess" element={<PaymentSuccess />} />
        <Route path="pages/PaymentCancel" element={<PaymentCancel />} />
        <Route path="pages/RegistrationCancel" element={<RegistrationCancel />} />
        <Route path="pages/RegistrationSuccess" element={<RegistrationSuccess />} />
        <Route path="pages/CGV" element={<CGV />} />
        <Route path="pages/InformationsLegales" element={<InformationsLegales />} />
        <Route path="pages/NosPartenaires" element={<NosPartenaires />} />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
